import * as Yup from 'yup';

export const RecordSchema = Yup.object()
                               .shape({
                                          phaseId: Yup.string()
                                                      .required('Required'),
                                          playbookId: Yup.string()
                                                         .required('Required'),
                                          name: Yup.string()
                                                   .required('Required'),
                                          position: Yup.number()
                                                       .typeError('Position must be a number')
                                                       .integer('Position must be an integer')
                                                       .min(0, 'Position must be zero or greater')
                                                       .required('Required'),
                                      });
